import type {DsFixerWithConfig} from './dsDataFixers'
import hoverToStateReactionFixer from './fixers/hoverToStateReactionFixer'

export default [
    {fixer: hoverToStateReactionFixer, config: {fixMobileOnly: false, fedopsTag: 'hoverToStateReactionFixer'}}
] as DsFixerWithConfig[]
